import { IComponentOptions } from "angular";
import { MachinesComponentsViewsMainController } from "./controller";

export const vsComponentName = "machinesView";

export const MachinesComponentsViewsMain: IComponentOptions = {
  controller: MachinesComponentsViewsMainController,
  controllerAs: "machinesViewController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridConfiguration: "<",
    reportGroup: "<",
  },
};
